import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@resy/ui-kitchen';
import { DownloadAppleButton } from '../../../svg';
import { handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import './ResyRewardsAppStoreButton.scss';

const ResyRewardsAppStoreButton = ({ appStoreUrl, eventAnalytics, sectionName }) => {
  if (!appStoreUrl) return null;

  const onClick = () => {
    const extraParams = {
      action_name: 'App Download - Click',
      item_name: `App Store - ${sectionName}`,
    };
    handleMktAnalytics(eventAnalytics, CTA_EVENT_NAME, extraParams);
  };

  return (
    <Button
      variant="no-style"
      href={appStoreUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="ResyRewardsAppStoreButton"
      aria-label="Download the Resy app on the App Store (opens in a new tab)"
      onClick={onClick}
      data-link="download-link"
    >
      <i className="ResyIcon" aria-hidden="true">
        <DownloadAppleButton />
      </i>
    </Button>
  );
};

ResyRewardsAppStoreButton.propTypes = {
  appStoreUrl: PropTypes.string,
  eventAnalytics: PropTypes.func,
  sectionName: PropTypes.string.isRequired,
};

ResyRewardsAppStoreButton.defaultProps = {
  appStoreUrl: '',
  eventAnalytics: null,
};

export default ResyRewardsAppStoreButton;
